// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "@firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyDSvft8CBrV5FWP2BA_XrUCM6-mB38qzoE",
    authDomain: "loveletter-app.firebaseapp.com",
    projectId: "loveletter-app",
    storageBucket: "loveletter-app.appspot.com",
    messagingSenderId: "75706791653",
    appId: "1:75706791653:web:466ddc73e41ae339dbc60c",
    measurementId: "G-N8NCG5MFVF"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app)
